import { render } from "./StafetOpretHoldStepOne.vue?vue&type=template&id=dcd72cc0"
import script from "./StafetOpretHoldStepOne.vue?vue&type=script&lang=js"
export * from "./StafetOpretHoldStepOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__